module.exports = __webpack_public_path__ + "static/media/halfstar.a4e7521a.svg";